export enum KnmPreviewActionsEnum {
  KNM_PREVIEW_INIT_PAGE = 'KNM_PREVIEW_INIT_PAGE',
  KNM_PREVIEW_SET_OPEN_API_INFO = 'KNM_PREVIEW_SET_OPEN_API_INFO',
  KNM_PREVIEW_SET_PASSPORT_DATA = 'KNM_PREVIEW_SET_PASSPORT_DATA',
  KNM_PREVIEW_DOWNLOAD_PASSPORT_PDF = 'KNM_PREVIEW_DOWNLOAD_PASSPORT_PDF',
}
